import * as React from 'react';
import * as moment from 'moment';
import { Button, ControlLabel, FormControl, FormGroup, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    onClose: () => void,
    onExport: (date: string) => void,
}

export const AsOfExportModal = (props: IProps) => {
    const [date, setDate] = React.useState(moment().format('YYYY-MM-DD'));

    return (
        <Modal show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Export As-Of</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormGroup>
                    <ControlLabel>As-of date</ControlLabel>
                    <FormControl
                        type='date'
                        value={date}
                        onChange={(e: React.FormEvent<FormControl & HTMLInputElement>) => setDate(e.currentTarget.value)}
                    />
                </FormGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onClose}>Cancel</Button>
                <Button bsStyle='primary' disabled={!date} onClick={() => props.onExport(date)}>Export</Button>
            </Modal.Footer>
        </Modal>
    );
}
